import {DeviceVisibilityRestDto} from "@/api/pharma-cms-content-page/models";

export class DeviceVisibilityRestDtoModel implements DeviceVisibilityRestDto {
    is_hidden_on_desktop: boolean;
    is_hidden_on_laptop: boolean;
    is_hidden_on_tablet: boolean;
    is_hidden_on_mobile: boolean;

    constructor(
        is_hidden_on_desktop: boolean,
        is_hidden_on_laptop: boolean,
        is_hidden_on_tablet: boolean,
        is_hidden_on_mobile: boolean,
    ) {
        this.is_hidden_on_desktop = is_hidden_on_desktop;
        this.is_hidden_on_laptop = is_hidden_on_laptop;
        this.is_hidden_on_tablet = is_hidden_on_tablet;
        this.is_hidden_on_mobile = is_hidden_on_mobile;
    }

    static createWithDefaults(): DeviceVisibilityRestDtoModel {
        return new this(false, false, false, false);
    }

    static cloneFrom(source: DeviceVisibilityRestDto): DeviceVisibilityRestDtoModel {
        return new this(
            source.is_hidden_on_desktop,
            source.is_hidden_on_laptop,
            source.is_hidden_on_tablet,
            source.is_hidden_on_mobile,
        );
    }
}
